module.exports = __webpack_public_path__ + "img/order.75dc6bfd.png";